/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  CancelMewsReservationRequest,
  CreateMewsReservationGroupRequest,
  GetMewsAgeConfigurationV1Params,
  GetMewsBookingEngineConfigurationV1Params,
  GetMewsBookingEngineProductsV1Params,
  GetMewsCategoriesRequest,
  GetMewsMultiCategoryAllocationRequest,
  GetMewsReservationGroupRequest,
  GetMewsVenuesV1Params,
  MewsBookingEngineConfigurationDto,
  MewsCategoriesResponseDto,
  MewsMultiCategoryAllocationResponseDto,
  MewsProductDto,
  ReservationDetailDto,
  ReservationGroupResponse,
  VenueDto
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMewsAgeConfigurationV1Response200 = {
  data: void
  status: 200
}

export type getMewsAgeConfigurationV1Response502 = {
  data: void
  status: 502
}

export type getMewsAgeConfigurationV1ResponseSuccess = (getMewsAgeConfigurationV1Response200) & {
  headers: Headers;
};
export type getMewsAgeConfigurationV1ResponseError = (getMewsAgeConfigurationV1Response502) & {
  headers: Headers;
};

export type getMewsAgeConfigurationV1Response = (getMewsAgeConfigurationV1ResponseSuccess | getMewsAgeConfigurationV1ResponseError)

export const getGetMewsAgeConfigurationV1Url = (params?: GetMewsAgeConfigurationV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/mews/age-configuration?${stringifiedParams}` : `/api/v1/reservations/mews/age-configuration`
}

/**
 * Returns age category definitions (Adult/Child classifications, age ranges) and the ChildSelectionEnabled flag from the Mews Booking Engine configuration. Optionally filter by serviceId.
 * @summary Get age categories and child-selection configuration
 */
export const getMewsAgeConfigurationV1 = async (params?: GetMewsAgeConfigurationV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMewsAgeConfigurationV1Response> => {

  return customFetch<getMewsAgeConfigurationV1Response>(getGetMewsAgeConfigurationV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMewsBookingEngineCategoriesV1Response200 = {
  data: MewsCategoriesResponseDto
  status: 200
}

export type getMewsBookingEngineCategoriesV1Response502 = {
  data: void
  status: 502
}

export type getMewsBookingEngineCategoriesV1ResponseSuccess = (getMewsBookingEngineCategoriesV1Response200) & {
  headers: Headers;
};
export type getMewsBookingEngineCategoriesV1ResponseError = (getMewsBookingEngineCategoriesV1Response502) & {
  headers: Headers;
};

export type getMewsBookingEngineCategoriesV1Response = (getMewsBookingEngineCategoriesV1ResponseSuccess | getMewsBookingEngineCategoriesV1ResponseError)

export const getGetMewsBookingEngineCategoriesV1Url = () => {




  return `/api/v1/reservations/mews/booking-engine/categories`
}

/**
 * Returns the resource categories (space types) aggregated from GetConfigurationResponse.Configurations[n].Enterprise.Categories, de-duplicated by Id, enriched with image assignments. When EnterpriseId, ServiceId, StartUtc and EndUtc are provided, each category also includes Availabilities — unit counts per time unit, positionally indexed with the top-level TimeUnitStartsUtc array.
 * @summary Get resource categories from Mews Booking Engine configuration
 */
export const getMewsBookingEngineCategoriesV1 = async (getMewsCategoriesRequest: GetMewsCategoriesRequest, options?: Parameters<typeof customFetch>[1]): Promise<getMewsBookingEngineCategoriesV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<getMewsBookingEngineCategoriesV1Response>(getGetMewsBookingEngineCategoriesV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getMewsCategoriesRequest)
  }
);}


export type getMewsBookingEngineConfigurationV1Response200 = {
  data: MewsBookingEngineConfigurationDto
  status: 200
}

export type getMewsBookingEngineConfigurationV1Response502 = {
  data: void
  status: 502
}

export type getMewsBookingEngineConfigurationV1ResponseSuccess = (getMewsBookingEngineConfigurationV1Response200) & {
  headers: Headers;
};
export type getMewsBookingEngineConfigurationV1ResponseError = (getMewsBookingEngineConfigurationV1Response502) & {
  headers: Headers;
};

export type getMewsBookingEngineConfigurationV1Response = (getMewsBookingEngineConfigurationV1ResponseSuccess | getMewsBookingEngineConfigurationV1ResponseError)

export const getGetMewsBookingEngineConfigurationV1Url = (params?: GetMewsBookingEngineConfigurationV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/mews/booking-engine/configuration?${stringifiedParams}` : `/api/v1/reservations/mews/booking-engine/configuration`
}

/**
 * Returns age categories, child-selection flag, rates, and service timing data (StartOffset, EndOffset, TimeUnit) for the given EnterpriseId + ServiceId. Single GetConfiguration call — no extra round-trips.
 * @summary Get combined Booking Engine configuration for a service
 */
export const getMewsBookingEngineConfigurationV1 = async (params?: GetMewsBookingEngineConfigurationV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMewsBookingEngineConfigurationV1Response> => {

  return customFetch<getMewsBookingEngineConfigurationV1Response>(getGetMewsBookingEngineConfigurationV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type getMewsBookingEngineMultiCategoryAllocationV1Response200 = {
  data: MewsMultiCategoryAllocationResponseDto
  status: 200
}

export type getMewsBookingEngineMultiCategoryAllocationV1Response400 = {
  data: void
  status: 400
}

export type getMewsBookingEngineMultiCategoryAllocationV1Response502 = {
  data: void
  status: 502
}

export type getMewsBookingEngineMultiCategoryAllocationV1ResponseSuccess = (getMewsBookingEngineMultiCategoryAllocationV1Response200) & {
  headers: Headers;
};
export type getMewsBookingEngineMultiCategoryAllocationV1ResponseError = (getMewsBookingEngineMultiCategoryAllocationV1Response400 | getMewsBookingEngineMultiCategoryAllocationV1Response502) & {
  headers: Headers;
};

export type getMewsBookingEngineMultiCategoryAllocationV1Response = (getMewsBookingEngineMultiCategoryAllocationV1ResponseSuccess | getMewsBookingEngineMultiCategoryAllocationV1ResponseError)

export const getGetMewsBookingEngineMultiCategoryAllocationV1Url = () => {




  return `/api/v1/reservations/mews/booking-engine/multi-category-allocation`
}

/**
 * Accepts multiple categories, each with total occupancy. Automatically splits persons into units per category using ceil(persons / capacity), mirroring category-allocation but for multiple categories in one call. When EnterpriseId, ServiceId, StartUtc and EndUtc are provided, checks availability per category and caps units to what is available, returning a WarningMessage when capped. Pricing calls are grouped by distinct personCount to minimise round-trips.
 * @summary Auto-calculate unit allocation for multiple categories
 */
export const getMewsBookingEngineMultiCategoryAllocationV1 = async (getMewsMultiCategoryAllocationRequest: GetMewsMultiCategoryAllocationRequest, options?: Parameters<typeof customFetch>[1]): Promise<getMewsBookingEngineMultiCategoryAllocationV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<getMewsBookingEngineMultiCategoryAllocationV1Response>(getGetMewsBookingEngineMultiCategoryAllocationV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getMewsMultiCategoryAllocationRequest)
  }
);}


export type getMewsBookingEngineProductsV1Response200 = {
  data: MewsProductDto[]
  status: 200
}

export type getMewsBookingEngineProductsV1Response502 = {
  data: void
  status: 502
}

export type getMewsBookingEngineProductsV1ResponseSuccess = (getMewsBookingEngineProductsV1Response200) & {
  headers: Headers;
};
export type getMewsBookingEngineProductsV1ResponseError = (getMewsBookingEngineProductsV1Response502) & {
  headers: Headers;
};

export type getMewsBookingEngineProductsV1Response = (getMewsBookingEngineProductsV1ResponseSuccess | getMewsBookingEngineProductsV1ResponseError)

export const getGetMewsBookingEngineProductsV1Url = (params?: GetMewsBookingEngineProductsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/mews/booking-engine/products?${stringifiedParams}` : `/api/v1/reservations/mews/booking-engine/products`
}

/**
 * Returns products de-duplicated by Id and ordered by Ordering. Path: GetConfigurationResponse.Configurations[n].Enterprise.Products. Each product includes Prices (currency → value), Amounts (currency → gross/net breakdown) and Pricing (discriminator + currency → Amount).
 * @summary Get products from Mews Booking Engine configuration
 */
export const getMewsBookingEngineProductsV1 = async (params?: GetMewsBookingEngineProductsV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMewsBookingEngineProductsV1Response> => {

  return customFetch<getMewsBookingEngineProductsV1Response>(getGetMewsBookingEngineProductsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type createMewsReservationGroupV1Response200 = {
  data: ReservationDetailDto
  status: 200
}

export type createMewsReservationGroupV1Response400 = {
  data: void
  status: 400
}

export type createMewsReservationGroupV1Response502 = {
  data: void
  status: 502
}

export type createMewsReservationGroupV1ResponseSuccess = (createMewsReservationGroupV1Response200) & {
  headers: Headers;
};
export type createMewsReservationGroupV1ResponseError = (createMewsReservationGroupV1Response400 | createMewsReservationGroupV1Response502) & {
  headers: Headers;
};

export type createMewsReservationGroupV1Response = (createMewsReservationGroupV1ResponseSuccess | createMewsReservationGroupV1ResponseError)

export const getCreateMewsReservationGroupV1Url = () => {




  return `/api/v1/reservations/mews/booking-engine/reservation-groups`
}

/**
 * Creates one Mews reservation per unit across all items, using the shared RateId, dates, and customer data from the request. EnterpriseId and ConfigurationId are sourced from the request and appsettings respectively.
 * @summary Create a reservation group in Mews Booking Engine
 */
export const createMewsReservationGroupV1 = async (createMewsReservationGroupRequest: CreateMewsReservationGroupRequest, options?: Parameters<typeof customFetch>[1]): Promise<createMewsReservationGroupV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<createMewsReservationGroupV1Response>(getCreateMewsReservationGroupV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createMewsReservationGroupRequest)
  }
);}


export type getMewsReservationGroupV1Response200 = {
  data: ReservationGroupResponse
  status: 200
}

export type getMewsReservationGroupV1Response404 = {
  data: void
  status: 404
}

export type getMewsReservationGroupV1Response502 = {
  data: void
  status: 502
}

export type getMewsReservationGroupV1ResponseSuccess = (getMewsReservationGroupV1Response200) & {
  headers: Headers;
};
export type getMewsReservationGroupV1ResponseError = (getMewsReservationGroupV1Response404 | getMewsReservationGroupV1Response502) & {
  headers: Headers;
};

export type getMewsReservationGroupV1Response = (getMewsReservationGroupV1ResponseSuccess | getMewsReservationGroupV1ResponseError)

export const getGetMewsReservationGroupV1Url = (reservationGroupId: string,) => {




  return `/api/v1/reservations/mews/booking-engine/reservation-groups/${reservationGroupId}`
}

/**
 * Fetches an existing reservation group by its ID. Use ExtentPaymentRequests and ExtentPayments to control which related data is included.
 * @summary Get a reservation group from Mews Booking Engine
 */
export const getMewsReservationGroupV1 = async (reservationGroupId: string,
    getMewsReservationGroupRequest: GetMewsReservationGroupRequest, options?: Parameters<typeof customFetch>[1]): Promise<getMewsReservationGroupV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<getMewsReservationGroupV1Response>(getGetMewsReservationGroupV1Url(reservationGroupId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getMewsReservationGroupRequest)
  }
);}


export type cancelMewsReservationV1Response200 = {
  data: string[]
  status: 200
}

export type cancelMewsReservationV1Response400 = {
  data: void
  status: 400
}

export type cancelMewsReservationV1Response502 = {
  data: void
  status: 502
}

export type cancelMewsReservationV1ResponseSuccess = (cancelMewsReservationV1Response200) & {
  headers: Headers;
};
export type cancelMewsReservationV1ResponseError = (cancelMewsReservationV1Response400 | cancelMewsReservationV1Response502) & {
  headers: Headers;
};

export type cancelMewsReservationV1Response = (cancelMewsReservationV1ResponseSuccess | cancelMewsReservationV1ResponseError)

export const getCancelMewsReservationV1Url = () => {




  return `/api/v1/reservations/mews/booking-engine/reservations/cancel`
}

/**
 * Cancels one or more Mews reservations by ID. EnterpriseId is sourced from the request or appsettings. Returns the list of cancelled reservation IDs.
 * @summary Cancel one or more reservations in Mews
 */
export const cancelMewsReservationV1 = async (cancelMewsReservationRequest: CancelMewsReservationRequest, options?: Parameters<typeof customFetch>[1]): Promise<cancelMewsReservationV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<cancelMewsReservationV1Response>(getCancelMewsReservationV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cancelMewsReservationRequest)
  }
);}


export type getMewsVenuesV1Response200 = {
  data: VenueDto[]
  status: 200
}

export type getMewsVenuesV1Response500 = {
  data: void
  status: 500
}

export type getMewsVenuesV1ResponseSuccess = (getMewsVenuesV1Response200) & {
  headers: Headers;
};
export type getMewsVenuesV1ResponseError = (getMewsVenuesV1Response500) & {
  headers: Headers;
};

export type getMewsVenuesV1Response = (getMewsVenuesV1ResponseSuccess | getMewsVenuesV1ResponseError)

export const getGetMewsVenuesV1Url = (params?: GetMewsVenuesV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/reservations/mews/venues?${stringifiedParams}` : `/api/v1/reservations/mews/venues`
}

/**
 * Returns venues that have at least one published + active BookableService. Pass serviceCategoryNodeKey to filter to a specific service category. Results are culture-aware via the Accept-Language header.
 * @summary List venues that offer Mews bookable services
 */
export const getMewsVenuesV1 = async (params?: GetMewsVenuesV1Params, options?: Parameters<typeof customFetch>[1]): Promise<getMewsVenuesV1Response> => {

  return customFetch<getMewsVenuesV1Response>(getGetMewsVenuesV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}


